/**
 * Offline cache for notebook sessions — always subordinate to Supabase API.
 * Cleared on each fresh route session so SPA re-entry cannot paint stale section ids.
 */

import { lsKey } from '../models/notebook-model'

export function clearNotebookLocalCache(notebookId) {
  if (typeof window === 'undefined' || !notebookId) return
  try {
    localStorage.removeItem(lsKey(notebookId))
  } catch {
    /* ignore */
  }
}

/** @returns {object | null} */
export function readNotebookLocalCache(notebookId) {
  if (typeof window === 'undefined' || !notebookId) return null
  try {
    const raw = localStorage.getItem(lsKey(notebookId))
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

/**
 * @param {string} notebookId
 * @param {{ notebook: object, activeTabId: string, locked?: boolean }} payload
 * @param {{ serverUpdatedAt?: string | null, source?: string }} [meta]
 */
export function writeNotebookLocalCache(notebookId, payload, meta = {}) {
  if (typeof window === 'undefined' || !notebookId) return
  try {
    localStorage.setItem(
      lsKey(notebookId),
      JSON.stringify({
        ...payload,
        savedAt: new Date().toISOString(),
        source: meta.source ?? 'server',
        serverUpdatedAt: meta.serverUpdatedAt ?? null,
      }),
    )
  } catch {
    /* quota exceeded */
  }
}
